import { FieldShell } from "./FieldShell";
import { brandInputClass } from "./fieldStyles";

function normalizePhoneDigits(value) {
  const digits = String(value ?? "").replace(/\D/g, "");

  const localDigits = digits.startsWith("598") ? digits.slice(3) : digits;
  const strippedLeadingZeros = localDigits.replace(/^0+/, "");

  if (!strippedLeadingZeros) {
    return "";
  }

  return strippedLeadingZeros.slice(0, 8);
}

function formatPhoneDigits(value) {
  const digits = normalizePhoneDigits(value);

  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 5) {
    return `${digits.slice(0, 2)} ${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
}

export function UruguayPhoneField({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  helper,
  placeholder = "99 999 999",
  required = false,
  className = "",
  showLabel = true,
}) {
  const handleChange = (event) => {
    const nextValue = normalizePhoneDigits(event.target.value);

    onChange?.({
      target: {
        name,
        value: nextValue,
      },
    });
  };

  return (
    <FieldShell
      label={label}
      helper={helper}
      error={error}
      className={className}
      showLabel={showLabel}
    >
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-4 flex items-center gap-2 text-brand-primary/70">
          <span
            aria-hidden="true"
            className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-primary/5 text-base"
          >
            🇺🇾
          </span>
          <span className="text-sm font-semibold">+598</span>
        </div>

        <input
          className={`${brandInputClass} pl-32`}
          name={name}
          value={formatPhoneDigits(value)}
          type="tel"
          inputMode="numeric"
          autoComplete="tel"
          onChange={handleChange}
          onBlur={onBlur}
          required={required}
          placeholder={placeholder}
          aria-invalid={Boolean(error)}
          maxLength={10}
        />
      </div>
    </FieldShell>
  );
}
